import { injectIntl } from 'react-intl';

import ProductSearch from './ProductSearch';

export default injectIntl(ProductSearch);
